import {ClickAwayListener, Paper, Popper} from '@mui/material';

import useProfile from '../../../../hooks/providers/useProfile';
import HeaderHelpRessourcesList from '../onbarding-help-ressources/HeaderHelpRessourcesList/HeaderHelpRessourcesList';
import HeaderOnboardingSingleFlow from '../onboarding-flows/HeaderOnboardingSingleFlow/HeaderOnboardingSingleFlow';

const HeaderOnboardingPopper = () => {
  const {onboardingData, setOnboardingPopperAnchorEl, setIsOnboardingPopperOpen, isOnboardingPopperOpen, onboardingPopperAnchorEl: anchorEl} = useProfile();

  const onClose = () => {
    setOnboardingPopperAnchorEl(null);
    setIsOnboardingPopperOpen(false);
  };

  const placement = 'bottom';
  const top = '20px !important';

  return (
    <Popper sx={{zIndex: 9999, top, maxWidth: 300, minWidth: 250}} placement={placement} anchorEl={anchorEl} open={isOnboardingPopperOpen}>
      <ClickAwayListener onClickAway={onClose}>
        <Paper
          sx={{
            boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.4)',
            borderRadius: 3
          }}
        >
          {onboardingData.map(flow => (
            <HeaderOnboardingSingleFlow key={flow.id} flow={flow} />
          ))}

          <HeaderHelpRessourcesList />
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export default HeaderOnboardingPopper;
